import { FirmanteNif, TipoFirma } from '../models/firmante-nif';
import { TipoDocumento } from '../models/tipo-documento';

/**
 * Post-procesado de documentos recien mapeados desde API (misma logica que
 * `RecuperaTipoDocumentoApiService` tras `mapDocumentosEntrada`).
 */
/** Id de sesion invalido: API de firmas siempre envia 0 (no persiste IdPosicionFirma). */
export function esIdPosicionFirmaInvalido(id: number | null | undefined): boolean {
  return id == null || id === 0;
}

export function normalizarDocumentoEntradaApi(doc: TipoDocumento): void {
  let idCasilla = 1;
  let idTipoContenido = 1;
  let idCampo = 1;
  let idFirma = 1;

  (doc.tiposContenido ?? []).forEach(item => {
    if (item.id == null) {
      item.id = idTipoContenido++;
    }
  });

  (doc.firmantesNif ?? []).forEach(firmante => {
    (firmante.firmas?.posicionFirmas ?? []).forEach(posicion => {
      if (!esIdPosicionFirmaInvalido(posicion.id) && posicion.id >= idFirma) {
        idFirma = posicion.id + 1;
      }
    });
  });

  (doc.firmantesNif ?? []).forEach(firmante => {
    normalizarFirmanteNifEntradaApi(firmante, doc.generico, doc.esCopiaBasica);
    (firmante.firmas?.posicionFirmas ?? []).forEach(posicion => {
      // Ids de sesion para locate/update/remove; 0 del API no discrimina tipo vs casillas/campos.
      if (esIdPosicionFirmaInvalido(posicion.id)) {
        posicion.id = idFirma++;
      }
    });
    (firmante.formularios ?? []).forEach(formulario => {
      if (formulario.id == null) {
        formulario.id = idCasilla++;
      }
    });
    (firmante.camposEditables ?? []).forEach(campo => {
      if (campo.id == null) {
        campo.id = idCampo++;
      }
    });
  });
}

export function normalizarFirmanteNifEntradaApi(
  firmante: FirmanteNif,
  generico = false,
  esCopiaBasica = false
): void {
  const firmas = firmante.firmas;
  if (!firmas) {
    return;
  }

  firmas.tipoFirma = normalizarTipoFirmaApi(
    firmas.tipoFirma,
    firmas.posicionFirmas?.length ?? 0
  );

  if (firmas.tipoFirma !== TipoFirma.Dibujada && firmas.tipoFirma !== TipoFirma.Certificado) {
    firmas.tieneTag = null as unknown as boolean;
  }

  if (firmante.nifOrden === 0 && !generico && !esCopiaBasica) {
    firmante.nifOrden = null as unknown as number;
  }
  if (firmante.nifPage === 0) {
    firmante.nifPage = null as unknown as number;
  }
}

/** Convierte valores API (`signer`, `dcf`, …) al enum `TipoFirma` del front. */
export function normalizarTipoFirmaApi(
  tipoFirma: TipoFirma | string | null | undefined,
  posicionFirmasCount = 0
): TipoFirma {
  if (tipoFirma === TipoFirma.Certificado || tipoFirma === 'dcf') {
    return TipoFirma.Certificado;
  }
  if (tipoFirma === TipoFirma.Validador || tipoFirma === 'validator') {
    return TipoFirma.Validador;
  }
  if (tipoFirma === TipoFirma.Dibujada) {
    return TipoFirma.Dibujada;
  }
  if (tipoFirma === 'signer' || tipoFirma === 'signature') {
    return posicionFirmasCount === 0 ? TipoFirma.SinFirma : TipoFirma.Dibujada;
  }
  // API a veces envia TipoFirma null/SinFirma pero con PosicionFirmas (p.ej. genericos).
  // Inferir Dibujada evita que Envio simple limpie a null y deje el panel sin tipo.
  if (posicionFirmasCount > 0) {
    return TipoFirma.Dibujada;
  }
  if (tipoFirma === TipoFirma.SinFirma) {
    return TipoFirma.SinFirma;
  }
  return TipoFirma.SinFirma;
}
